import styled from "@emotion/styled";
import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { find, has } from "lodash";

import UserContent from "~/components/UserContent";
import ErrorBoundary from "~/components/ErrorBoundary";

import Form from "~/queryBlocks/Form";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

import { h2 } from "~/styles/typographyStyles";

const H2 = styled.h2`
    ${h2};
    text-align: center;
`;

const getKCGatedFormByProductLine = (productLine, kcForms) => {
    const form = find(kcForms, { productLineSlug: productLine });
    return has(form, "formId") ? form.formId : "";
};

const GatedArticle = ({
    copy = "",
    runOnSubmit,
    productLine = "",
    presetValues,
    runOnSubmitActions = null,
    overrideFormId = -1,
}) => {
    const {
        wp: { formsOptionsPage },
    } = useStaticQuery(graphql`
        query StaticGatedArticleQuery {
            wp {
                formsOptionsPage {
                    knowledgeCenterGatedForm {
                        forms {
                            formId
                            productLineSlug
                        }
                    }
                }
            }
        }
    `);

    const kcForms = formsOptionsPage?.knowledgeCenterGatedForm?.forms;
    const formId =
        overrideFormId > 0
            ? overrideFormId
            : getKCGatedFormByProductLine(productLine, kcForms);

    return (
        <ErrorBoundary>
            {copy ? (
                <UserContent isKCArticle>
                    {sanitizeAndParseHTML(copy)}
                </UserContent>
            ) : null}

            {formId ? (
                <ErrorBoundary>
                    <H2>Unlock Access</H2>
                    <Form
                        {...{
                            runOnSubmit,
                            runOnSubmitActions,
                            formId,
                        }}
                        formPresetValues={presetValues}
                    />
                </ErrorBoundary>
            ) : null}
        </ErrorBoundary>
    );
};

GatedArticle.propTypes = {
    copy: PropTypes.string,
    runOnSubmit: PropTypes.func.isRequired,
    productLine: PropTypes.string,
    storageName: PropTypes.string,
    runOnSubmitActions: PropTypes.object,
    overrideFormId: PropTypes.number,
};

export default GatedArticle;
